import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  videoPlayer: {
    aspectRatio: '16/9',
    width: '100%',
    height: 500,
    [theme.breakpoints.down('md')]: {
      maxWidth: '100%',
      height: 400,
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
      height: 300,
    },
    [theme.breakpoints.down('xs')]: {
      height: 140,
    },
  },
  settingsContainer: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    flexDirection: 'row',
    gap: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: theme.spacing(1),
    },
  },
  tabButton: {
    display: 'flex',
    gridGap: theme.spacing(2),
    padding: 10,
    justifyContent: 'space-between',
    borderColor: theme.palette.custom.border,
    backgroundColor: theme.palette.common.white,
    boxShadow: 'none',
  },
  tabsContainer: {
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
    gridGap: theme.spacing(2),
  },
  activeTab: {
    borderColor: theme.palette.primary.main,
  },
}))

export default styles
